import "./styles/tailwind-base.css";
import "@pinpoint/brand/tokens.css";
import "./styles/index.css";
import { initProductSentry } from "./config/sentry";
import { installDeployChunkRecovery } from "./lib/deployChunkRecovery";

initProductSentry();

// Route-root imports are runtime entrypoints too: the rollback composition must
// receive the same styling initialization as the standalone app. Product API
// clients initialize their own transport from config/apiOrigin.
installDeployChunkRecovery({
  releaseIdentifier: import.meta.env.VITE_RENDER_GIT_COMMIT,
});
